module.exports = __webpack_public_path__ + "static/media/om_hairstyle_loose_back.f4cf3f58.png";